module.exports = __webpack_public_path__ + "static/media/screen-video-proces.86a9ba57.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/About/video-screenshots/screen-video-proces.jpg
// module id = 745
// module chunks = 0